// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OTPAuthenticationModal-form-input {
  padding-left: 15px;
  letter-spacing: 42px;
  /* border: 0; */
  /* background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 50px 1px;
  background-repeat: repeat-x;
  background-position-x: 35px; */
  width: 350px;
  outline: none;
  text-align: center;
}

.OTPAuthenticationModal-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/OTPauthenticationModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf;;;;gCAI8B;EAC9B,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":[".OTPAuthenticationModal-form-input {\n  padding-left: 15px;\n  letter-spacing: 42px;\n  /* border: 0; */\n  /* background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);\n  background-position: bottom;\n  background-size: 50px 1px;\n  background-repeat: repeat-x;\n  background-position-x: 35px; */\n  width: 350px;\n  outline: none;\n  text-align: center;\n}\n\n.OTPAuthenticationModal-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
